"use client";

// Filterkopf der Mitgliederliste — gebaut aus dem Listen-Baukasten des
// Agent (`components/liste`), wie `kunden-filterkopf.tsx` dort.
import { UsersRound } from "lucide-react";
import {
  Auswahlfeld,
  Filterkopf,
  Filterzurueck,
  Fuge,
  Luecke,
  Schiene,
  Suchfeld,
  useAnsicht,
  Zaehlknopf,
  Zaehlschiene,
  type Auswahl,
} from "@/components/liste";
import { ALLE_PARAMS, PRUEFUNGEN, ZUSTAENDE, aktiveFilter, type Ansicht } from "@/lib/mitglieder/ansicht";

export function MitgliederFilterkopf({
  ansicht,
  zustandZaehler,
  pruefZaehler,
  gruppen,
}: {
  ansicht: Ansicht;
  zustandZaehler: Record<string, number>;
  pruefZaehler: Record<string, number>;
  gruppen: Auswahl[];
}) {
  const { setzen, isPending } = useAnsicht();
  const haupt = ZUSTAENDE.slice(0, 4);
  const weitere = ZUSTAENDE.slice(4);

  return (
    <Filterkopf
      isPending={isPending}
      oben={
        <>
          <Suchfeld wert={ansicht.q} platzhalter="Name, Nummer, Mail, Ort …" beschriftung="Mitglieder durchsuchen" />
          <Luecke />
          <Zaehlschiene titel="Zustand">
            {haupt.map((z, i) => (
              <span key={z.schluessel || "mitglieder"} className="contents">
                {i === 1 && <Fuge />}
                <Zaehlknopf
                  label={z.label}
                  anzahl={zustandZaehler[z.schluessel] ?? 0}
                  aktiv={ansicht.zustand === z.schluessel}
                  titel={z.hinweis}
                  onClick={() => setzen({ zustand: z.schluessel || null, umfang: null })}
                />
              </span>
            ))}
          </Zaehlschiene>
          <Schiene>
            {weitere.map((z) => (
              <Zaehlknopf
                key={z.schluessel}
                label={z.label}
                anzahl={zustandZaehler[z.schluessel] ?? 0}
                aktiv={ansicht.zustand === z.schluessel}
                titel={z.hinweis}
                onClick={() => setzen({ zustand: ansicht.zustand === z.schluessel ? null : z.schluessel, umfang: null })}
              />
            ))}
          </Schiene>
        </>
      }
      unten={
        <>
          <Auswahlfeld
            icon={UsersRound}
            titel="Gruppe"
            label="Gruppe"
            eintraege={gruppen}
            gewaehlt={ansicht.gruppe}
            onWaehlen={(id) => setzen({ gruppe: id, umfang: null })}
            suchtext="Gruppe suchen …"
            alleLabel="Alle Gruppen"
            leerText="Keine Gruppe gefunden"
          />
          <Schiene>
            {PRUEFUNGEN.map((p) => (
              <Zaehlknopf
                key={p.schluessel}
                label={p.label}
                anzahl={pruefZaehler[p.schluessel] ?? 0}
                aktiv={ansicht.pruefung === p.schluessel}
                ton={p.schluessel === "mandat" || p.schluessel === "offen" ? "gefahr" : "normal"}
                titel={p.hinweis}
                onClick={() => setzen({ pruefung: ansicht.pruefung === p.schluessel ? null : p.schluessel, umfang: null })}
              />
            ))}
          </Schiene>
          <Luecke />
          <Filterzurueck anzahl={aktiveFilter(ansicht)} params={ALLE_PARAMS} />
        </>
      }
    />
  );
}
